// Constants
import { BUTTON_BORDER_RADIUS } from "Constants/theme";
import { boxShadowCard } from "Constants/ColourConstants";

export const styles = {
  container: (paper) => ({
    backgroundColor: paper ? "background.paper" : "background.default",
    boxShadow: boxShadowCard,
    borderRadius: BUTTON_BORDER_RADIUS,
    gap: 1,
    px: { xs: 2, sm: 2.5 },
    py: { xs: 2, sm: 1.5 },
    boxSizing: "border-box",
    justifyContent: { xs: "flex-start", sm: "space-between" },
    alignItems: { xs: "flex-start", sm: "center" },
  }),
  infoGroup: {
    justifyContent: "flex-start",
    gap: 2,
    flexWrap: "wrap",
  },
  infoCell: (fullWidth) => ({
    minWidth: 0,
    maxWidth: "100%",
    width: fullWidth ? { xs: "100%", sm: "auto" } : "auto",
    flex: { xs: "1 1 auto", sm: "0 0 auto" },
    px: 1,
    boxSizing: "border-box",
  }),
  valueTypography: {
    maxWidth: "100%",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
    whiteSpace: "normal",
  },
};
